const getAppVersion = () => localStorage.getItem('app-version')

const setAppVersion = version => localStorage.setItem('app-version', version)

export { getAppVersion, setAppVersion }
